export const environment = {
  production: false,
  app: 'backoffice',
  version: '',
  title: '[LOCAL] Overa Backoffice',
};
